import React, { useState, useEffect } from "react";

//Images
import ProgressBar from "../Progressbar";
import UpArrow from "../../Assets/Svg/Auth/UpArrow.svg";
import DownArrow from "../../Assets/Svg/Auth/DownArrow.svg";

//Component
import Button from "../Button";

//Style
import "./styles.scss";

function DropdownDetails({
  headingName,
  details,
  perfomanceRating,
  performanceScore,
  scoresData = [],
  assessmentId,
  handleViewDetails,
  openAll = false,
  isSparePart,
}) {
  const [isOpen, setIsOpen] = useState(openAll);

  // Sync `isOpen` state with `openAll` prop changes
  useEffect(() => {
    setIsOpen(openAll);
  }, [openAll]);

  const toggleDropdown = () => {
    if(isSparePart) return;
    setIsOpen(!isOpen);
  };

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: "2px",
      }}
    />
  );

  const progressBarfillcolor = "#58BCBD";

  return (
    <div className="dropdown-container-details">
      <div className="dropdown-heading" onClick={toggleDropdown}>
        <h3>{headingName}</h3>
        {!isSparePart && <div className="arrow-container">
          {isOpen ? (
            <img src={UpArrow} alt="collapse" width="30" height="30" />
          ) : (
            <img src={DownArrow} alt="expand" width="30" height="30" />
          )}
        </div>}
      </div>

      <div className="dropdown-details">
        <div className="details" onClick={toggleDropdown}>
          <div>{details}</div>
          <h3>{perfomanceRating}/5</h3>
          {/* <div className="performance-score">
            <div className="performance-details">
              <p>Performance</p>
              <p>{performanceScore}</p>
            </div>
            <ProgressBar
              completedPercentage={performanceScore}
              fillColor={progressBarfillcolor}
              ProgressBarStyle={{ height: "5px" }}
            />
          </div> */}
        </div>
        <Button
          title="View Details"
          buttonStyle={{
            fontSize: "1rem",
            cursor: "pointer",
            padding: "10px 30px 10px 30px",
          }}
          onClick={() => handleViewDetails(assessmentId)}
          titleStyle={{
            fontSize: "1rem",
            color: "white",
            whiteSpace: "nowrap",
          }}
        />
      </div>
      {isOpen && (
        <>
          <div className="dropdown-scores">
            <br></br>
            <ColoredLine color={"#464646"} />
            <br></br>
            <div className="score">
              {Array.isArray(scoresData) && scoresData.map((item, index) => (
                <div key={index} className="score-item">
                  <h5>{item.heading}</h5>
                  <div>
                    <div className="title-detail">
                      {/* <p>Score</p> */}
                      <p>{item.score}</p>
                    </div>
                    <ProgressBar
                      completedPercentage={item.score * 20}
                      fillColor={progressBarfillcolor}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default DropdownDetails;
